document.addEventListener("DOMContentLoaded", function () {
  var switchImages = document.querySelectorAll(".switch_img");
  if (!switchImages.length) return;

  var spMediaQuery = window.matchMedia("(max-width: 768px)");

  var setState = function (switchImage, state) {
    switchImage.dataset.switchState = String(state);
  };

  switchImages.forEach(function (switchImage) {
    setState(switchImage, 1);
    switchImage.setAttribute("role", "button");
    switchImage.setAttribute("tabindex", "0");

    switchImage.addEventListener("mouseenter", function () {
      if (spMediaQuery.matches) return;
      setState(switchImage, 2);
    });

    switchImage.addEventListener("mouseleave", function () {
      if (spMediaQuery.matches) return;
      setState(switchImage, 1);
    });

    switchImage.addEventListener("click", function () {
      if (spMediaQuery.matches) {
        var currentState = Number(switchImage.dataset.switchState || 1);
        setState(switchImage, currentState >= 3 ? 1 : currentState + 1);
        return;
      }

      setState(switchImage, 3);
    });

    switchImage.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;

      event.preventDefault();
      switchImage.click();
    });
  });

  spMediaQuery.addEventListener("change", function () {
    switchImages.forEach(function (switchImage) {
      setState(switchImage, 1);
    });
  });
});

(function () {
  var DUR    = 420;
  var SHOWN  = 'inset(0 0% 0 0)';
  var HIDDEN = 'inset(0 100% 0 0)';

  document.querySelectorAll('.switch_img').forEach(function (figure) {
    var imgs = Array.from(figure.querySelectorAll('.img_1, .img_2, .img_3'));

    imgs.forEach(function (img, i) {
      img.style.transition = 'none';
      img.style.clipPath   = i === 0 ? SHOWN : HIDDEN;
      img.style.zIndex     = i === 0 ? '1' : '0';
    });

    var current = 0, rafId = null, timerId = null;

    function show(toIdx) {
      if (toIdx === current) return;
      var fromIdx = current;
      current = toIdx;
      if (rafId)   { cancelAnimationFrame(rafId); rafId = null; }
      if (timerId) { clearTimeout(timerId); timerId = null; }
      imgs.forEach(function (img, i) {
        img.style.transition = 'none';
        if (i === toIdx)        { img.style.clipPath = HIDDEN; img.style.zIndex = '1'; }
        else if (i === fromIdx) { img.style.clipPath = SHOWN;  img.style.zIndex = '0'; }
        else                    { img.style.clipPath = HIDDEN; img.style.zIndex = '0'; }
      });
      rafId = requestAnimationFrame(function () {
        rafId = requestAnimationFrame(function () {
          imgs[toIdx].style.transition = 'clip-path ' + DUR + 'ms ease';
          imgs[toIdx].style.clipPath   = SHOWN;
          timerId = setTimeout(function () {
            imgs[fromIdx].style.clipPath = HIDDEN; timerId = null;
          }, DUR + 20);
        });
      });
    }

    var trigger = figure.closest('.img_fit');
    trigger.addEventListener('mouseenter', function () { show(1); });
    trigger.addEventListener('mouseleave', function () { show(0); });
    trigger.addEventListener('mousedown',  function (e) {
      e.preventDefault();
      if (current === 1) show(2);
    });
  });
}());